<template>
  <div>
    <div id="modal-pyramid" class="modal fade" aria-hidden="true" ref="editPyramid">
      <div class="modal-dialog">
        <div class="">
          <div class="modal-body ibox">
            <div class="col-lg-12">
              <div class="ibox ">
                <div class="ibox-title">
                  <h5>Link Pyramid</h5>
                  <div class="ibox-tools">
                    <a class="close-modal" data-dismiss="modal">
                      <i class="fa fa-times"></i>
                    </a>
                  </div>
                </div>
                <div class="ibox-content">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="form-group">
                        <div class="row">
                          <div class="col-lg-12">
                            <div class="row m-t-md">
                              <div class="col-lg-12">
                                <div class="col-lg-4">
                                  <div class="col-lg-4">
                                    <label for="iName">Name:</label>
                                  </div>
                                </div>
                                <div class="col-lg-8">
                                  <input type="text" name="name" id="iName" ref="iName" class="col-lg-10">
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-12">
                            <div class="row m-t-md">
                              <div class="col-lg-12">
                                <div class="col-lg-4">
                                  <div class="col-lg-4">
                                    <label for="iUrl">Url:</label>
                                  </div>
                                </div>
                                <div class="col-lg-8">
                                  <textarea  name="url" id="iUrl" ref="iUrl" cols="30" rows="10" placeholder="1 url per line" class="col-lg-10"></textarea>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-12">
                            <div class="row m-t-md">
                              <div class="col-lg-12">
                                <div class="col-lg-4">
                                  <div class="col-lg-4">
                                    <label for="iDesc">Description:</label>
                                  </div>
                                </div>
                                <div class="col-lg-8">
                                  <textarea name="desc" id="iDesc" ref="iDesc" class="col-lg-10"></textarea>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-12">
                            <div class="row m-t-md">
                              <div class="col-lg-12">
                                <div class="col-lg-4">
                                  <div class="col-lg-4">
                                    <label for="iBlacklist">Blacklist:</label>
                                  </div>
                                </div>
                                <div class="col-lg-8">
                                  <textarea name="desc" id="iBlacklist" ref="iBlacklist" class="col-lg-10"></textarea>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-lg-12">
                      <button class="btn btn-sm btn-default label-primary" type="submit" @click="savePyramid">Save</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="wrapper wrapper-content animated fadeInUp">
          <div class="ibox">
            <div class="ibox-title">
              <h5>Link Pyramids</h5>
              <div class="ibox-tools">
                <button class="btn btn-primary btn-xs" id="addPyramid" data-toggle="modal" data-target="#modal-pyramid">Create new</button>
              </div>
            </div>
            <div class="ibox-content">
              <div class="row m-b-sm m-t-sm">
                <pyramid-list v-if="renderComponent"></pyramid-list>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import PyramidList from './link-pyramid/List'
export default {
  name: 'LinkPyramid',
  data () {
    return {
      renderComponent: true
    }
  },
  components: {
    pyramidList: PyramidList
  },
  mounted () {
  },
  methods: {
    savePyramid () {
      axios.post('link-pyramid', {
        name: this.$refs.iName.value,
        url: this.$refs.iUrl.value,
        description: this.$refs.iDesc.value,
        blacklist: this.$refs.iBlacklist.value
      })
        .then(r => {
          $('#modal-pyramid').modal('hide')
          this.renderComponent = false
          this.$nextTick(() => {
            this.renderComponent = true
          })
          this.$refs.iName.value = ''
          this.$refs.iDesc.value = ''
          this.$refs.iUrl.value = ''
          this.$refs.iBlacklist.value = ''
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Apps/LinkPyramid.vue